import DeletePositionType from "./DeletePositionType";
export default DeletePositionType;
